import React, { useEffect, useState } from 'react';

interface SilentLoginProps {
    onLoginSuccess: () => void;
    onLoginFailure: () => void;
}

export const SilentLogin: React.FC<SilentLoginProps> = ({
    onLoginSuccess,
    onLoginFailure,
}) => {
    const [iframeSrc, setIframeSrc] = useState<string | null>(null);

    useEffect(() => {
        const handleBffMessage = (event: MessageEvent) => {
            // Security check: Validate the origin matches your backend host
            if (event.origin !== window.location.origin) {
                return;
            }

            if (event.data?.isLoggedIn) {
                onLoginSuccess();
            } else if (!event.data?.isLoggedIn) {
                onLoginFailure();
            }
        };

        window.addEventListener('message', handleBffMessage);

        // Modern BFFs (like Duende v4) use the login endpoint with prompt=none
        setIframeSrc('/bff/login?prompt=none');

        return () => {
            window.removeEventListener('message', handleBffMessage);
        };
    }, [onLoginSuccess, onLoginFailure]);

    if (!iframeSrc) {
        return null;
    }

    return (
        <iframe
            src={iframeSrc}
            style={{ display: 'none' }}
            title="bff-silent-login"
            sandbox="allow-same-origin allow-scripts allow-forms"
        />
    );
};